import morph from "../helpers/morph";

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

window.cartContentRequestId = 1;

class CartContent extends HTMLElement {
  constructor() {
    super();

    this._updateQty = debounce(({ key, quantity }) => {
      window.changeCart(
        { id: key, quantity },
        {
          onError: () => this._refreshCart(),
          data: {
            requestId: ++window.cartContentRequestId,
          },
        },
      );
    }, 150);

    this.addEventListener("click", (e) => {
      const removeButton = e.target.closest("[data-remove]");

      if (!removeButton) return;
      const item = e.target.closest("[data-item-key]");

      this._updateQty({ key: item.dataset.itemKey, quantity: 0 });
    });

    document.addEventListener("updateCart", (e) => {
      const requestId = e.detail.data?.requestId;

      // Debounce - cancel update if another request is already in progress.
      if (requestId === window.cartContentRequestId || !requestId) {
        this._updateCart(e.detail.cart.sections[this.sectionId]);
      }
    });

    this.addEventListener("change", (e) => {
      const item = e.target.closest("[data-item-key]");
      if (!item) return;

      this._updateQty({
        key: item.dataset.itemKey,
        quantity: parseInt(e.target.value, 10),
      });
    });

    this.trackEl = this.querySelector(".mini-cart__scroll-content");

    this.observer = new IntersectionObserver(
      (entries) => {
        this.trackEl.classList.toggle(
          "scrolled-to-end",
          entries[0].isIntersecting,
        );
      },
      {
        root: this.trackEl,
        rootMargin: "5px 5px 5px 5px",
      },
    );

    this._addScrollTarget();
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  _addScrollTarget() {
    if (this.target) {
      this.observer.unobserve(this.target);
      this.target.remove();
    }

    this.target = document.createElement("div");
    this.target.classList.add("scroll-tracker-target");
    this.trackEl.append(this.target);
    this.observer.observe(this.target);
  }

  _refreshCart() {
    window
      .fetchPageData({
        path: "/cart",
        options: { sectionId: this.sectionId },
      })
      .then((markup) => this._updateCart(markup));
  }

  _updateCart(markup) {
    const html = new DOMParser().parseFromString(markup, "text/html");
    const sourceContent = html.querySelector(".mini-cart__content");
    morph(this, sourceContent);
    this._addScrollTarget();
  }

  get sectionId() {
    return this.getAttribute("cart-section-id");
  }
}

if (!customElements.get("cart-content")) {
  customElements.define("cart-content", CartContent);
}
